export default "__VITE_ASSET__Wiw830$f__"